import { drawers } from './generated/drawers';
import { pages } from './generated/pages';

export const paths = {
  pages,
  drawers,
};
